<ion-content>
  <div class="setup-content">
    <!-- Back Button -->
    <ion-button
      fill="clear"
      class="back-button"
      (click)="goBack()">
      <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
    </ion-button>

    <!-- Main Question -->
    <h1 class="setup-question">
      {{ 'SETUP.CUSTOMIZE_EXPERIENCE' | translate }}
    </h1>

    <!-- Theme Section -->
    <div class="preference-section">
      <h2 class="preference-title">{{ 'SETUP.THEME' | translate }}</h2>
      <div class="theme-buttons">
        <div class="theme-btn" [class.active]="!darkMode" (click)="darkMode = false; onThemeChange()">
          <ion-icon name="sunny"></ion-icon>
          <span>{{ 'SETUP.LIGHT_MODE' | translate }}</span>
        </div>
        <div class="theme-btn" [class.active]="darkMode" (click)="darkMode = true; onThemeChange()">
          <ion-icon name="moon"></ion-icon>
          <span>{{ 'SETUP.DARK_MODE' | translate }}</span>
        </div>
      </div>
    </div>

    <!-- Continue Button -->
    <ion-button
      expand="block"
      color="success"
      class="continue-button"
      (click)="savePreferences()">
      {{ getButtonText() }}
      <ion-icon name="checkmark" slot="end"></ion-icon>
    </ion-button>
  </div>
</ion-content>
